var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "overview-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.287,
    height: 20.287,
    viewBox: "0 0 20.287 20.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40082",
    "data-name": "Path 40082",
    d: "M10.143,0A10.143,10.143,0,1,0,20.287,10.143,10.138,10.138,0,0,0,10.143,0ZM9.271,3.316a.873.873,0,1,1,1.745,0V4.341a.873.873,0,1,1-1.745,0Zm-4.952,7.7H3.294a.873.873,0,1,1,0-1.745H4.319a.873.873,0,0,1,0,1.745ZM6.653,6.631a.889.889,0,0,1-1.243.022l-.72-.742A.879.879,0,0,1,5.933,4.668l.72.72A.869.869,0,0,1,6.653,6.631Zm4.6,5.824a2.435,2.435,0,0,1-1.113.24A2.557,2.557,0,0,1,8.878,7.918a2.511,2.511,0,0,1,2.356-.087L14.375,4.69a.879.879,0,1,1,1.243,1.243L12.456,9.053A2.557,2.557,0,0,1,11.256,12.456Zm5.715-1.44H15.946a.873.873,0,1,1,0-1.745h1.025a.873.873,0,1,1,0,1.745Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.c3af358c21176c9856eb9da5b4f2c2ca.svg";
export { ForwardRef as ReactComponent };